import { noop } from 'lodash-es';
import { createContext, PropsWithChildren, useState } from 'react';

import { ThemeEnum } from '@enum/style/theme.enum';

interface ThemeContextInterface {
  theme: ThemeEnum;
  setTheme: (theme: ThemeEnum) => void;
}

export const ThemeContext = createContext<ThemeContextInterface>({
  theme: ThemeEnum.Light,
  setTheme: noop,
});

export const ThemeProvider = ({ children }: PropsWithChildren) => {
  const [theme, setTheme] = useState(ThemeEnum.Light);

  return <ThemeContext.Provider value={{ theme, setTheme }}>{children}</ThemeContext.Provider>;
};
